// utils/gtag.js

export function sendGtagEvent(eventName, eventData = {}) {
  try {
    if (typeof window.gtag !== 'function') {
      console.warn('[gtag] gtag is not defined');
      return;
    }

    if (!eventName || typeof eventName !== 'string') {
      console.error('[gtag] Invalid event name:', eventName);
      return;
    }

    if (typeof eventData !== 'object' || eventData === null) {
      console.error('[gtag] Event data must be an object');
      return;
    }

    if (process.env.NODE_ENV !== 'production') {
      eventData.debug_mode = true;
    }

    window.gtag('event', eventName, eventData);
    console.log(`[gtag] Event sent: ${eventName}`, eventData);
  } catch (error) {
    console.error(`[gtag] Failed to send event "${eventName}"`, error);
  }
}

export function trackAddToCart(courseId, price) {
  sendGtagEvent('add_to_cart', {
    course_id: courseId,
    value: price,
    currency: 'USD',
  });
}

export function trackBeginCheckout(courseId, price) {
  sendGtagEvent('begin_checkout', {
    course_id: courseId,
    value: price,
    currency: 'USD',
  });
}

export function trackPurchase(enrollmentId, course_id, course_name, price) {
  sendGtagEvent('purchase', {
    transaction_id: enrollmentId,
    value: price,
    currency: 'USD',
    items: [
      {
        item_id: course_id || 'unknown_course',
        item_name: course_name || 'Unknown Course',
        price: price,
        quantity: 1,
      }
    ],
  });
}
